import { http } from "@canvas/api";

export interface GetCmsProductDetailsReq {
  endpoint: "cmsapi.v2.products.:productId.getdetails";
  productId: string | number;
}

export interface GetCmsProductDetailsRes {
  [key: string]: any;
}

// interface SkuDetails {
//   id: number;
//   code: string;
//   product_id: number;
//   display_name: string;
// }

export function get(
  req: GetCmsProductDetailsReq
): Promise<GetCmsProductDetailsRes> {
  return http
    .GET(`/cmsapi/v2/products/${req.productId}`)
    .then((response: GetCmsProductDetailsRes) => {
      // validate response here
      return response;
    })
    .catch(err => {
      return Promise.reject(err);
    });
}
